import React from "react";

const Vision = () => {
  return (
    <>
      <div className="bg-white font-bold text-[#e64a32] text-left sm:pl-6 md:pl-8 lg:pl-12 sm:pr-4 md:pr-6 lg:pr-8">
        <div className="text-3xl sm:text-4xl lg:text-5xl mb-6 mt-6">Vision</div>
        <div className="text-sm sm:text-sm md:text-sm mb-4 text-gray-900">
        <p>To be a global leader in innovative card games that promote holistic well-being and empower individuals to achieve balance in their personal and professional lives, while fostering micro-entrepreneurship and community growth.</p>
        <p>We envision a world where entertainment blends seamlessly with education and empowerment, inspiring individuals to embrace the PASSION FRAMEWORK to make meaningful contributions to society.</p>
        </div>
        <div className="text-3xl sm:text-4xl lg:text-5xl mb-6 mt-6">Mission</div>
        <div className="text-sm sm:text-sm md:text-sm mb-4 text-gray-900">
        <p>-Empower Individuals: Design card games that educate, inspire, and guide individuals toward self-awareness, skill-building, and ethical decision-making.</p>
        <p>-Foster Communities: Create a platform for players to connect, collaborate, and build supportive networks for holistic well-being.</p>
        <p>-Encourage Entrepreneurship: Enable players to become entrepreneurs by understanding the mechanics of the game and building thriving communities around it.</p>
        <p>-Promote Ethical Gaming: Develop games that actively discourage addictive behaviors while fostering positive transformation through introspection and action.</p>
        <p>-Leverage Technology: Integrate advanced tools like LLMs to enhance the gaming experience, enabling deeper insights into human behavior and decision-making.</p>
        <p>-Celebrate Humanity: Uphold the values of peace, respect, trust, unity, and love while acknowledging the complexities of human nature and materialism.</p>
        </div>
      </div>
      <div className="bg-white p-4 sm:p-6 md:p-8 rounded-lg shadow-md mb-8 sm:pl-6 md:pl-8 lg:pl-12 sm:pr-4 md:pr-6 lg:pr-8">
        <div className="text-2xl sm:text-3xl font-bold text-[#e64a32] mb-4">
          PASSION FRAMEWORK
        </div>
        <div className="text-base sm:text-lg md:text-xl font-medium">
          A 2-decade old research initiated as PASSION, a concept to help the jobless community and build entrepreneurship ecosystem. It evolved as a framework as part of a PhD Thesis by Dr. Prakash Sharma, who has 30+ years of experience in the IT industry. The framework has 7 Dimension and 28 process areas, and we actively engage senior thought leaders, technical leads, academicians to focus on practical research/pain points within their existing companies or experiences and build entrepreneurship-focused research papers/articles in any of chosen process areas. There are opportunities to cofound companies, initiate startup at absolute low cost and contribute to society. Our blog which explains entrepreneurship using stories and poems has over 98 country viewership. Our virtual incubation PCOMBINATOR has been benchmarked as one of the top 10% accelerator program with reference to competency development.
          <br />
          <br />
          <a
            href="https://www.linkedin.com/in/dr-prakash-sharma-330743a3/?originalSubdomain=in"
            className="text-[#e64a32] underline"
          >
            Linkedin
          </a>
          <br />
          Look forward to active participation.
        </div>
         {/* Footer */}
      <footer className="mt-6 text-gray-600 text-center text-sm">
        © 2025 Passionit.com All rights reserved. |{" "}
        <a href="https://passionit.com/index.php/privacy-policy/" className="text-[#e64a32] hover:underline">
          Privacy Policy
        </a>{" "}
        |{" "}
        <a href="https://passionit.com/index.php/childrens-terms-and-conditions/" className="text-[#e64a32] hover:underline">
          Children’s Terms and Conditions
        </a>{" "}
        |{" "}
        <a href="/ai-policy" className="text-[#e64a32] hover:underline">
        AI Policy Terms and Conditions
      </a>
      </footer>
      </div>
    </>
  );
};

export default Vision;
